import { render, staticRenderFns } from "./SelectPacakge.vue?vue&type=template&id=2b91821e&"
import script from "./SelectPacakge.vue?vue&type=script&lang=js&"
export * from "./SelectPacakge.vue?vue&type=script&lang=js&"
import style0 from "./SelectPacakge.vue?vue&type=style&index=0&id=2b91821e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports